(() => {
  // Desktop-only hover magnifier for Dawn product media.
  const mql = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!mql.matches) return;

  const ZOOM_RATIO = 2;

  const getSrc = (img) => img.currentSrc || img.src;

  const createOverlay = (img, src) => {
    const overlay = document.createElement('div');
    overlay.className = 'image-magnify-full-size';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.backgroundImage = `url('${src}')`;
    overlay.style.backgroundColor = 'var(--gradient-background)';
    overlay.style.backgroundRepeat = 'no-repeat';
    return overlay;
  };

  const moveWithPointer = (img, overlay, event) => {
    const rect = overlay.getBoundingClientRect();

    // Guard against 0x0 rects
    if (!rect.width || !rect.height) return;

    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const xPercent = `${(x / rect.width) * 100}%`;
    const yPercent = `${(y / rect.height) * 100}%`;

    overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;

    // Prefer naturalWidth (actual pixels) so the zoom feels real.
    const naturalW = img.naturalWidth || img.width;
    overlay.style.backgroundSize = `${naturalW * ZOOM_RATIO}px`;
  };

  const bindOne = (toggle) => {
    if (toggle.dataset.magnifyBound === '1') return;
    toggle.dataset.magnifyBound = '1';

    const opener = toggle.closest('modal-opener');
    const img = opener?.querySelector('img.image-magnify-hover');
    const media = img?.parentElement; // .product__media
    if (!img || !media) return;

    let overlay = null;

    const show = (event) => {
      if (overlay && overlay.isConnected) return;

      overlay = createOverlay(img, getSrc(img));
      media.insertBefore(overlay, img);

      // Visual cue that we're in magnify mode.
      img.style.opacity = '0.5';

      // Prime a first position (use center if event coords are missing)
      const e = event?.clientX
        ? event
        : {
            clientX: media.getBoundingClientRect().left + media.getBoundingClientRect().width / 2,
            clientY: media.getBoundingClientRect().top + media.getBoundingClientRect().height / 2,
          };
      moveWithPointer(img, overlay, e);
    };

    const move = (event) => {
      if (!overlay || !overlay.isConnected) return;
      moveWithPointer(img, overlay, event);
    };

    const hide = () => {
      overlay?.remove();
      overlay = null;
      img.style.opacity = '';
    };

    // The toggle button sits above the image (it captures pointer events),
    // so we bind hover/move/leave to it instead of the <img>.
    toggle.addEventListener('pointerenter', show);
    toggle.addEventListener('pointermove', move);
    toggle.addEventListener('pointerleave', hide);

    // If the image changes (carousel/variant), reset.
    img.addEventListener('load', hide);
  };

  const bindAll = () => {
    document.querySelectorAll('.product__media-toggle.product__media-zoom-hover').forEach(bindOne);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
})();
